import { COMMON_TEXT } from '@/helpers/common-text';
import { extractValueFromQueryResponse, getConfigurationUrlWithParam } from '@/helpers/utility';
import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { fetchAuditWriteLog } from './query-request';
import { formatDateTime } from '@/helpers/utility';
import { connect } from 'react-redux';
import { QUERY_STRING_STORE } from '@/helpers/constants';
import LoadingSpinner from '@/components/CustomComponent/LoadingSpinner';
import './AuditWriteLog.less';

@connect(state => ({
  querystring: state.querystring,
}))
class AuditWriteLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tenant: this.props?.querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0],
      isLoading: false,
      tableData: [],
      searchFilters: {
        timestamp: '',
        actor: '',
        httpMethod: '',
        url: '',
        content: '',
      },
      pagination: {
        first: 0,
        rows: 10,
        totalRecords: 0,
      },
    };
    this.searchTimeout = null;
  }

  componentDidMount() {
    const { tenant } = this.state;
    if (tenant) {
      this.setState({ tenant }, () => {
        this.loadData();
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { querystring } = this.props;
    const { querystring: prevQuerystring } = prevProps;
    const tenant = querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const prevTenant = prevQuerystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    if (tenant !== prevTenant) {
      this.setState({ tenant }, () => {
        this.loadData();
      });
    }
  }

  componentWillUnmount() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
    }
  }

  loadData = async () => {
    this.setState({ isLoading: true });
    const { querystring } = this.props;
    const { pagination, searchFilters } = this.state;
    const tenantId = querystring?.[QUERY_STRING_STORE.SELECT_BOX_TENANT]?.[0];
    const offset = pagination.first;
    const limit = pagination.rows;

    try {
      const response = await fetchAuditWriteLog({
        tenantId,
        limit,
        offset,
        filters: searchFilters
      });

      const result = extractValueFromQueryResponse(response);
      const totalRecords = response.count || 0;

      this.setState({
        tableData: result || [],
        pagination: {
          ...pagination,
          totalRecords: parseInt(totalRecords) || 0
        },
        isLoading: false
      });
    } catch (error) {
      console.error('Error loading audit write log data:', error);
      this.setState({
        tableData: [],
        pagination: {
          ...pagination,
          totalRecords: 0
        },
        isLoading: false
      });
    }


    this._resizeObserver = null;
    const configWindow = document.querySelector('div.config-window');
    const dataTableWrapper = document.querySelector('.p-datatable-wrapper');
    function updateDataTableHeight() {
      if (configWindow && dataTableWrapper) {
        const height = configWindow.offsetHeight;
        dataTableWrapper.style.height = `${height - 175}px`;
      }
    }
    if (configWindow && dataTableWrapper) {
      this._resizeObserver = new window.ResizeObserver(() => {
        updateDataTableHeight();
      });
      this._resizeObserver.observe(configWindow);
      updateDataTableHeight();
    }
  };

  goBackToConfigPage = () => {
    const { querystring } = this.props;
    window.location.href = getConfigurationUrlWithParam({ querystring });
  };

  handlePageChange = (event) => {
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
        first: event.first,
        rows: event.rows,
      }
    }), () => {
      this.loadData();
    });
  };

  renderSearchSection() {
    const { searchFilters } = this.state;

    const handleSearchChange = (field, value) => {
      // Clear existing timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      this.setState({
        searchFilters: {
          ...searchFilters,
          [field]: value,
        },
        pagination: {
          ...this.state.pagination,
          first: 0, // Reset to first page when filtering
        }
      }, () => {
        // Debounce the search to avoid too many API calls
        this.searchTimeout = setTimeout(() => {
          this.loadData();
        }, 500);
      });
    };

    const SearchIcon = () => (
      <svg className="search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.3333 15.5L9.08333 10.25C8.66667 10.5833 8.1875 10.8472 7.64583 11.0417C7.10417 11.2361 6.52778 11.3333 5.91667 11.3333C4.40278 11.3333 3.12153 10.809 2.07292 9.76042C1.02431 8.71181 0.5 7.43056 0.5 5.91667C0.5 4.40278 1.02431 3.12153 2.07292 2.07292C3.12153 1.02431 4.40278 0.5 5.91667 0.5C7.43056 0.5 8.71181 1.02431 9.76042 2.07292C10.809 3.12153 11.3333 4.40278 11.3333 5.91667C11.3333 6.52778 11.2361 7.10417 11.0417 7.64583C10.8472 8.1875 10.5833 8.66667 10.25 9.08333L15.5 14.3333L14.3333 15.5ZM5.91667 9.66667C6.95833 9.66667 7.84375 9.30208 8.57292 8.57292C9.30208 7.84375 9.66667 6.95833 9.66667 5.91667C9.66667 4.875 9.30208 3.98958 8.57292 3.26042C7.84375 2.53125 6.95833 2.16667 5.91667 2.16667C4.875 2.16667 3.98958 2.53125 3.26042 3.26042C2.53125 3.98958 2.16667 4.875 2.16667 5.91667C2.16667 6.95833 2.53125 7.84375 3.26042 8.57292C3.98958 9.30208 4.875 9.66667 5.91667 9.66667Z" fill="white" />
      </svg>
    );

    return (
      <div className="search-inputs-container">
        <div className="search-input-wrapper">
          <SearchIcon />
          <input
            type="text"
            placeholder="タイムスタンプ"
            value={searchFilters.timestamp}
            onChange={(e) => handleSearchChange('timestamp', e.target.value)}
            className="search-input"
          />
        </div>
        <div className="search-input-wrapper">
          <SearchIcon />
          <input
            type="text"
            placeholder="変更者"
            value={searchFilters.actor}
            onChange={(e) => handleSearchChange('actor', e.target.value)}
            className="search-input"
          />
        </div>
        <div className="search-input-wrapper">
          <SearchIcon />
          <input
            type="text"
            placeholder="HTTPメソッド"
            value={searchFilters.httpMethod}
            onChange={(e) => handleSearchChange('httpMethod', e.target.value)}
            className="search-input"
          />
        </div>
        <div className="search-input-wrapper">
          <SearchIcon />
          <input
            type="text"
            placeholder="URL"
            value={searchFilters.url}
            onChange={(e) => handleSearchChange('url', e.target.value)}
            className="search-input"
          />
        </div>
      </div>
    );
  }

  customSortIcon = (options) => {
    let iconSrc;
    if (options.sorted) {
      if (options.sortOrder < 0) {
        iconSrc = "/assets/img/sort-down-icon.svg";
      } else {
        iconSrc = "/assets/img/sort-up-icon.svg";
      }
    } else {
      iconSrc = "/assets/img/sort-icon.svg";
    }
    return (
      <img
        src={iconSrc}
        alt="sort"
        className="custom-sort-icon"
        {...options.iconProps}
      />
    );
  };

  renderDataTable = () => {
    const { tableData, pagination, isLoading } = this.state;

    return (
      <div className="table-container audit-write-log-table-container">
        <DataTable
          key={`audit-table-${pagination.totalRecords}-${pagination.first}`}
          value={tableData}
          paginator
          lazy
          loading={isLoading}
          rows={pagination.rows}
          rowsPerPageOptions={[10, 20, 50]}
          first={pagination.first}
          totalRecords={parseInt(pagination.totalRecords) || 0}
          tableStyle={{ minWidth: '60rem' }}
          scrollable
          scrollHeight="100%"
          size="medium"
          stripedRows
          rowHover
          showGridlines
          sortIcon={this.customSortIcon}
          onPage={this.handlePageChange}
          emptyMessage={() => {
            return (
              <div className="no-data-container">
                {COMMON_TEXT.NO_DATA}
              </div>
            );
          }}
        >
          <Column
            field="timestamp"
            header={COMMON_TEXT.AUDIT_WRITE_LOG_TIMESTAMP}
            body={(rowData) => formatDateTime(rowData.timestamp)}
            sortable
            style={{ minWidth: '160px' }}
          />
          <Column
            field="actor"
            header={COMMON_TEXT.AUDIT_WRITE_LOG_ACTOR}
            sortable
            style={{ minWidth: '180px' }}
          />
          <Column
            field="http_method"
            header={COMMON_TEXT.AUDIT_WRITE_LOG_HTTP_METHOD}
            sortable
            style={{ minWidth: '120px' }}
          />
          <Column
            field="url"
            header={COMMON_TEXT.AUDIT_WRITE_LOG_URL}
            sortable
            style={{ minWidth: '200px' }}
          />
          <Column
            field="content"
            header={COMMON_TEXT.AUDIT_WRITE_LOG_CONTENT}
            style={{ minWidth: '300px' }}
          />
        </DataTable>
      </div>
    );
  }

  render() {
    const { isLoading } = this.state;

    return (
      <div className="config-container custom-config-container audit-write-log-container custom-setting-config-container">
        <div className="config-title-container">
          <div className="text-left">
            <div className="title-text">
              {COMMON_TEXT.AUDIT_WRITE_LOG}
            </div>
          </div>
        </div>
        <div className="config-content">
          {this.renderSearchSection()}
          <div className="setting-content">
            {isLoading ? (
              <div className="ml-auto mr-auto">
                <LoadingSpinner />
              </div>
            ) : (
              this.renderDataTable()
            )}
          </div>
        </div>
      </div>
    );
  }
}

AuditWriteLog.propTypes = {};

export default AuditWriteLog; 